namespace $ {

	export type $shm_projects_version_sort_record = {
		version: string
		date: string
		stage?: string
	}

	export function $shm_projects_version_sort< Record extends $shm_projects_version_sort_record >(
		records: readonly Record[],
	) {
		const date_key = ( value: string )=> {
			const match = value.match( /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/ )
			return match ? Number( `${ match[3] }${ match[2].padStart( 2, '0' ) }${ match[1].padStart( 2, '0' ) }` ) : 0
		}
		const version_parts = ( value: string )=> value.split( /[.+-]/ ).map( part => Number( part ) || 0 )

		return [ ... records ].sort( ( left, right )=> {
			const date = date_key( right.date ) - date_key( left.date )
			if( date ) return date
			const left_version = version_parts( left.version )
			const right_version = version_parts( right.version )
			for( let index = 0; index < Math.max( left_version.length, right_version.length ); ++ index ) {
				const version = ( right_version[ index ] ?? 0 ) - ( left_version[ index ] ?? 0 )
				if( version ) return version
			}
			return String( right.stage ?? '' ).localeCompare( String( left.stage ?? '' ), 'ru' )
		} )
	}

}
